import { escapeHtml } from './escapeHtml';
import type { SerializeOptions } from './serializeOptions';
import { AUTHOR_ID_ATTRIBUTE_NAME } from '../comment-markup';
import type { CastText } from '../types';

/**
 * Wrapping order (innermost → outermost):
 *   text → <u>/<s>/<i>/<b> → <del>/<ins>
 * Redlines wrap appearance, keeping author-tracking "outside" the formatting so
 * downstream consumers can strip styles without losing redline structure. Font
 * metrics (family/size) are not emitted here — they live on the section and
 * paragraph tags (see serializeParagraph / serializeCast).
 */
export function serializeText(text: CastText, options: SerializeOptions): string {
  if (text.value === '') return '';

  let inner = escapeHtml(text.value);

  if (options.emitInlineStyles && text.style) {
    if (text.style.underline) inner = `<u>${inner}</u>`;
    if (text.style.strikethrough) inner = `<s>${inner}</s>`;
    if (text.style.italic) inner = `<i>${inner}</i>`;
    if (text.style.bold) inner = `<b>${inner}</b>`;
  }

  if (options.emitRedlines) {
    if (text.deleteAuthorId !== undefined) {
      inner = `<del ${AUTHOR_ID_ATTRIBUTE_NAME}="${escapeHtml(text.deleteAuthorId)}">${inner}</del>`;
    }
    if (text.insertAuthorId !== undefined) {
      inner = `<ins ${AUTHOR_ID_ATTRIBUTE_NAME}="${escapeHtml(text.insertAuthorId)}">${inner}</ins>`;
    }
  }

  return inner;
}
